export const WITHDRAWAL_WALLET_START = 'WITHDRAWAL_WALLET_START';
export const WITHDRAWAL_WALLET_SUCCESS = 'WITHDRAWAL_WALLET_SUCCESS';
export const WITHDRAWAL_WALLET_ERROR = 'WITHDRAWAL_WALLET_ERROR';
